import {
  Box,
  IconButton,
  Popover,
  Typography,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CalendarCard from "components/dashboard/CalendarCard";
import { useState } from "react";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";

const TopBarCalendar = observer(() => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const today = dayjs();
  const open = Boolean(anchorEl);

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <IconButton
          color="inherit"
          onClick={handleOpen}
          sx={{ cursor: "pointer" }}
        >
          <CalendarTodayIcon />
        </IconButton>
        <Typography variant="body2">{today.format("DD MMM YYYY")}</Typography>
      </Box>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: { sx: { overflow: "visible" } },
        }}
      >
        <CalendarCard />
      </Popover>
    </>
  );
});

export default TopBarCalendar;
